import { Box } from "@mui/system";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { LoginProvider } from "../../contexts/LoginContext";
import Create from "./Create";
import EmailConfirmation from "./EmailConfirmation";
import Login from "./Login";
import PasswordRecovery from "./PasswordRecovery";
import withRedirectIfAlreadyLoggedIn from "../../hocs/withRedirectIfAlreadyLoggedIn";
import EmailConfirmationCallback from "./EmailConfirmationCallback";
import NewPassword from "./NewPassword";
const LoginPageContainer: React.FC = () => {
  return (
    <Box>
      <LoginProvider>
        <Routes>
          <Route element={<Login />} path="/" />
          <Route element={<PasswordRecovery />} path="/forgot" />
        </Routes>
      </LoginProvider>
    </Box>
  );
};

const SignUpPageContainer: React.FC = () => {
  return (
    <Box>
      <LoginProvider>
        <Routes>
          <Route element={<Create />} path="/" />
          <Route element={<EmailConfirmation />} path="/confirm" />
          <Route element={<EmailConfirmationCallback />} path="/verify" />
          <Route element={<NewPassword />} path="/newpassword" />
        </Routes>
      </LoginProvider>
    </Box>
  );
};

export const LoginPage = withRedirectIfAlreadyLoggedIn(LoginPageContainer);
export const SignUpPage = withRedirectIfAlreadyLoggedIn(SignUpPageContainer);
